function customKit() {
  const isDebug = false;
  const baseStyles = [
    "color: #fff",
    "background-color: #1779E1",
    "padding: 2px 8px",
    "border-radius: 4px"
  ].join(";");
  function consoleLog() {
    if (window.console && isDebug === true) {
      console.log('%cDD-DEBUG', baseStyles, ...Array.prototype.slice.call(arguments));
    }
  };

  consoleLog('customKit init');

  const canvas = document.querySelector("#ck-canvas");
  const imgUploaded = new Image();
  imgUploaded.src = "";
  const imgPixel = new Image();
  imgPixel.src = canvas.getAttribute("data-pixel-square-src");
  let uploadImg = "";

  document.querySelectorAll(".ck-trigger-upload").forEach(
    (e) => { 
      e.addEventListener("click", function () {
        consoleLog("ck-trigger-upload clicked");

        if (window.aiUrl) {
          consoleLog('AI URL detected', window.aiUrl);

          // open TOS, then once they agree, trigger the upload
          $('.ai-tos-trigger').trigger('click');
          return;
        }
        document.querySelector("#custom_photo_init").click();
      });
    }
  );

  // trigger upload upon TOS acceptance
  $('.ai-tos-agree').on('click', function () {
    document.querySelector('#ai-tos').setAttribute('open', 'true');
    document.querySelector("#custom_photo_init").dispatchEvent(new Event('change'));
    
    document.querySelector('.custom-product-properties').appendChild(document.createElement('input')).setAttribute('type', 'text');
    document.querySelector('.custom-product-properties').lastElementChild.setAttribute('name', 'properties[AI-Generated]');
    document.querySelector('.custom-product-properties').lastElementChild.setAttribute('class', 'hidden');
    document.querySelector('.custom-product-properties').lastElementChild.setAttribute('value', 'Yes');
    $('.ai-tos-trigger').trigger('click');
  });

  document
    .querySelector("#custom_photo_init")
    .addEventListener("change", async function () {
      consoleLog('custom_photo_init changed');

      let uploadedFile = undefined;

      // normal file upload
      if (!uploadedFile && this.files && this.files[0]) {
        uploadedFile = this.files[0];
        document.querySelector("#custom_photo_init").files = this.files;
      }

      // ai upload
      if (window.aiUrl) {
        // pull the image from the server
        // place into a file object, as a blob
        let response = await fetch(window.aiUrl);
        let data = await response.blob();
        let metadata = {
          type: 'image/png'
        };
        let file = new File([data], "generated.png", metadata);
        
        // create a new data transfer object to then insert into the file input
        let container = new DataTransfer();
        container.items.add(file);
        this.files = container.files;
        
        window.aiFile = file;
        uploadedFile = window.aiFile;
      }
      consoleLog('Uploaded file is', uploadedFile);
      
      if (uploadedFile) {
        consoleLog('User uploaded a file', uploadedFile);

        var imgSize = uploadedFile.size;
        console.log("imgSize", imgSize);
        if (imgSize > 20 * 1024 * 1024) {
          alert("Image size limitation: No more than 20MB!");
          return false;
        }
        
        document.querySelector(".ck_upload_box").classList.add("ck-hide");
        document.querySelector(".ck-section").classList.remove("ck-hide");
        document.querySelector(".ck-upload-loading").style.display = "block";
        getImgBase64Data(uploadedFile, function (res) {
          consoleLog('Image converted to base64');
          uploadImg = res;
          setTimeout(function () {
            updateDimensions();
          }, 200);
        });

        const canvasY = document.querySelector(".ck-section").getBoundingClientRect().top + window.scrollY - 230;
        consoleLog('scrollTo ck-section', canvasY);
        window.scrollTo({
          top: canvasY,
          left: 0,
          behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto"
        });
        // document.querySelector("#step_text_1").style.display = "none";
        // document.querySelector("#step_text_1_detail").style.display = "none";

        // const copied = document.querySelector('#custom_photo_init').cloneNode(true);
        // copied.id = 'custom_photo_init_copy';
        // document.querySelector('.custom_kit_image').appendChild(copied);
      }
    });

  const abDrillFormInput = document.querySelector('#custom_photo_ab_drill');
  document
    .querySelector('input[name="ab-drills"]')
    .addEventListener("change", function () {
      consoleLog('AB-drills changed', this.checked);

      if (this.checked) {
        abDrillFormInput.value = "Yes";
      } else {
        abDrillFormInput.value = "No";
      }
    });

  function updateDimensions() {
    consoleLog('updateDimensions');

    const inputDimensions = document.querySelector(
      'input[name="option1"]'
    ).value;

    // pixel style
    const inputDiamondSize = document.querySelector('input[name="option2"]').value;
    imgPixel.src = canvas.getAttribute("data-pixel-square-src");
    if (inputDiamondSize && inputDiamondSize === "Round") {
      imgPixel.src = canvas.getAttribute("data-pixel-circle-src");
    }

    // dimensions
    const size = inputDimensions;
    const width = size.replace("cm", "").split("x")[0];
    const height = size.replace("cm", "").split("x")[1];
    canvas.width = width * 38;
    canvas.height = height * 38;

    document.getElementById("ck-canvas").style.visibility = "hidden";
    setTimeout(function () {
      updateCanvas();
    }, 200);
  }

  // dimensions
  document
    .querySelector('input[name="option1"]')
    .addEventListener("change", function () {
      consoleLog('Dimensions changed');
      updateDimensions();
    });

  // diamond style
  document
    .querySelector('input[name="option2"]')
    .addEventListener("change", function () {
      consoleLog('Diamond style changed');
      updateDimensions();
    });

  // canvas zoom
  document.querySelector("#zoomIn").addEventListener("click", () => {
    consoleLog('zoomIn');
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 1.5);
  });
  document.querySelector("#zoomIn").addEventListener("touchstart", () => {
    consoleLog('zoomIn');
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 1.5);
  });
  document.querySelector("#zoomOut").addEventListener("click", () => {
    consoleLog('zoomOut');
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 0.75);
  });
  document.querySelector("#zoomOut").addEventListener("touchstart", () => {
    consoleLog('zoomOut');
    zoomInstance.zoomTo(canvas.width / 2, canvas.height / 2, 0.75);
  });
  var zoomElement = document.querySelector("#ck-canvas");
  var zoomInstance = panzoom(zoomElement, {
    maxZoom: 10,
    minZoom: 1,
    bounds: true,
    boundsPadding: 1,
    zoomDoubleClickSpeed: 1,
  });

  function getImgBase64Data(file, callback) {
    var reader = new FileReader();
    reader.onload = function (e) {
      callback(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  function updateCanvas() {
    consoleLog('updateCanvas');

    var scale = {
      value: 10,
    };
    var ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = false;
    imgUploaded.src = uploadImg;
    imgUploaded.onload = function () {
      var ratio;
      var cw;
      var ch;
      if (imgUploaded.width > imgUploaded.height) {
        ratio = imgUploaded.width / imgUploaded.height;
        cw = canvas.height * ratio;
        ch = canvas.height;
      } else {
        ratio = imgUploaded.height / imgUploaded.width;
        cw = canvas.width;
        ch = canvas.width * ratio;
      }
      var sw = (cw / scale.value) >> 0;
      var sh = (ch / scale.value) >> 0;
      ctx.drawImage(imgUploaded, 0, 0, sw, sh);
      ctx.lineWidth = 0.5;
      var p = 1;
      for (var x = 0; x <= canvas.width; x += 10) {
        ctx.moveTo(x, p);
        ctx.lineTo(x, canvas.height);
      }
      for (var x = 0; x <= ch; x += 10) {
        ctx.moveTo(0, p + x);
        ctx.lineTo(cw, 0 + x);
      }
      var xOffset = cw > canvas.width ? (canvas.width - cw) / 2 : 0;
      var yOffset = ch > canvas.height ? (canvas.height - ch) / 2 : 0;
      yOffset = Math.ceil(yOffset / 10) * 10;
      xOffset = Math.ceil(xOffset / 10) * 10;
      ctx.drawImage(canvas, 0, 0, sw, sh, xOffset, yOffset, cw, ch);
      setTimeout(function () {
        var pat = ctx.createPattern(imgPixel, "repeat");
        ctx.rect(0, 0, cw, ch);
        ctx.strokeStyle = "rgba(0,0,0,0.1)";
        ctx.fillStyle = pat;
        ctx.fill();
        document.getElementById("ck-canvas").style.visibility = "visible";
        document.querySelector(".ck-upload-loading").style.display = "none";
      }, 800);
    };
  }

  // TODO figure out if YES/NO submitting correctly
  // document.body.addEventListener("click", function (event) {
  //   if (event.target.matches("#operations span")) {
  //     let item = event.target.getAttribute("type");
  //     if (item == "1") {
  //       document.querySelector("#operationsVal").value = "Yes";
  //     } else {
  //       document.querySelector("#operationsVal").value = "No";
  //     }
  //     event.target.classList.add("activeBtnStyle");
  //     var siblings = event.target.parentNode.children;
  //     for (var i = 0; i < siblings.length; i++) {
  //       if (siblings[i] !== event.target) {
  //         siblings[i].classList.remove("activeBtnStyle");
  //       }
  //     }
  //   }
  // });

  // show/hide ability to buy based on checking off the terms
  // document.querySelector('.buy-buttons').style.display = "none";
  // document.querySelectorAll('.acceptTerms input').forEach(function (input) {
  //   input.addEventListener("click", function () {
  //     var unchecked = document.querySelectorAll('.acceptTerms input:not(:checked)').length;
  //     if (unchecked == 0) {
  //       document.querySelector('.buy-buttons').disabled = false;
  //       document.querySelector('.buy-buttons').style.display = "flex";
  //     } else {
  //       document.querySelector('.buy-buttons').disabled = true;
  //       document.querySelector('.buy-buttons').style.display = "none";
  //     }
  //   });
  // });
  // document.body.addEventListener('click', function (event) {
  //   if (event.target.matches(".single-option-selector")) {
  //     var unchecked = document.querySelectorAll('.acceptTerms input:not(:checked)').length;
  //     if (unchecked == 0) {
  //       document.querySelector('.buy-buttons').disabled = false;
  //       document.querySelector('.buy-buttons').style.display = "flex";
  //     } else {
  //       document.querySelector('.buy-buttons').disabled = true;
  //       document.querySelector('.buy-buttons').style.display = "none";
  //     }
  //   }
  // });
}

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function mobileChangeCustomKitElementPlacement() {
  if (window.mobileCheck() === false) return;
  
  const whereCustomStepsGo = document.querySelector('.product-info__custom-kit .text-gray-400.pb-6.block');
  const customSteps = document.querySelector('.custom--steps-1-3');

  const customDesc = document.querySelector('.product-info__custom-kit .product-info__description .prose');
  const productDescription = document.querySelector('.product-info > .product-info__description');

  const disclaimer = document.querySelector('.ck_disclaimer_wrapper');
  const productInfo = document.querySelector('.product-info');

  if (customSteps && whereCustomStepsGo) {
    productDescription.parentNode.insertBefore(customDesc, productDescription.nextSibling);
    whereCustomStepsGo.parentNode.insertBefore(customSteps, whereCustomStepsGo.nextSibling);
    productInfo.parentNode.insertBefore(disclaimer, productInfo.nextSibling);
  }
}

document.addEventListener("DOMContentLoaded", function() {
  customKit();
  mobileChangeCustomKitElementPlacement();
});